// @ts-strict-ignore
import React from 'react'
import { Breadcrumbs, Typography } from '@mui/material'
import StyledLink from 'components/StyledLink'
import { makeStyles } from 'tss-react/mui'
import { slugify } from 'services/formatting'

interface IBreadcrumb {
  name: string
  href: string
}

export interface IBreadcrumbs extends Array<IBreadcrumb>{}

export interface IPageHeaderBreadcrumbsProps {
  breadcrumbs: IBreadcrumbs
}

const useStyles = makeStyles()(theme => ({
  container: {
    marginTop: `${theme.spacing(0.5)} !important`,
    marginBottom: `${theme.spacing(-1)} !important`,
  },
  breadcrumbLink: {
    textDecoration: 'none',
    color: theme.palette.secondary[300],
    fontStyle: 'normal',
    lineHeight: '12px',
  },
}))

const PageHeaderBreadcrumbs: React.FunctionComponent<IPageHeaderBreadcrumbsProps> = (props: IPageHeaderBreadcrumbsProps) => {
  const { breadcrumbs } = props
  const { classes } = useStyles()

  return (
    <Breadcrumbs aria-label="breadcrumb" className={classes.container}>
      {breadcrumbs.map((breadcrumb, index) => {
        const key = slugify(breadcrumb.name)
        const last = index === breadcrumbs.length - 1

        if (last || !breadcrumb.href) {
          return (
            <Typography key={key} color="textPrimary" variant="body1" style={{ lineHeight: '20px' }}>
              {breadcrumb.name}
            </Typography>
          )
        }

        return (
          <StyledLink key={key} href={breadcrumb.href} className={classes.breadcrumbLink}>
            {breadcrumb.name}
          </StyledLink>
        )
      })}
    </Breadcrumbs>
  )
}

export default React.memo(PageHeaderBreadcrumbs)
